import { CircularProgress, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as React from "react";
import { If } from "react-extras";

interface LoadingIndicatorProps {
  text?: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  centered: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
}));

const LoadingIndicator = ({ text }: LoadingIndicatorProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.centered}>
      <CircularProgress size={64} />
      <If condition={!!text}>
        <Typography variant="h4">{text}</Typography>
      </If>
    </div>
  );
};

export default LoadingIndicator;
